import apiRequest from "../../helpers/apiRequest";

export default async (body) => {
    return await apiRequest({
        method: 'get',
        url: `accounts/all_tutor_schedule/`,
    })
}
